// store/moduleAuth.js
import axios from 'axios';

function getUserIdFromToken(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    const payload = JSON.parse(jsonPayload);
    return payload.id;
  } catch (e) {
    console.error('Erreur lors du décodage du token JWT:', e);
    return null;
  }
}

const moduleAuth = {
  namespaced: true, // <----- IMPORTANT
  state: {
    isAuthenticated: false,
  },
  mutations: {
    setAuthentication(state, { isAuthenticated}) {
      state.isAuthenticated = isAuthenticated;
      // state.userId = userId;
      // state.userEmail = userEmail;
    }
  },
  actions: {
    async checkAuthentication({ commit }) {
      const token = localStorage.getItem('token');
      if (token) {
        // const userId = getUserIdFromToken(token);
        // let userEmail = null;
        // try {
        //   const response = await axios.get('https://127.0.0.1:8000/api/user/email', {
        //     headers: {
        //       'Authorization': `Bearer ${token}`
        //     }
        //   });
        //   userEmail = response.data.email;
        // } catch (error) {
        //   console.error('Erreur lors de la récupération de l\'email de l\'utilisateur:', error);
        // }
        commit('setAuthentication', { isAuthenticated: true});
      } else {
        commit('setAuthentication', { isAuthenticated: false});
      }
    },
    async login({ commit }, { token }) {
      localStorage.setItem('token', token);
      const userId = getUserIdFromToken(token);
      let userEmail = null;
      const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
      // Construction de l'URL
      try {
        const response = await axios.get(`${API_URL}/api/user/email`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        userEmail = response.data.email;
      } catch (error) {
        console.error('Erreur lors de la récupération de l\'email de l\'utilisateur:', error);
      }
      commit('setAuthentication', { isAuthenticated: true, userId, userEmail });
    },
    logout({ commit }) {
      localStorage.removeItem('token');
      commit('setAuthentication', { isAuthenticated: false, userId: null, userEmail: null });
    }
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    userId: state => state.userId,
    userEmail: state => state.userEmail
  }
};

export default moduleAuth;
